{
  "more": "Další položky"
}
